import axios from '../index'
import { GET_USER_INFO } from './api'
import { HTTP_ERR_SUCCESS_MESSAGE } from '@/constant/api_status'
import { ERROR_DEFAULT_HTTP_REQUEST_FAIL } from '@/constant/error'

/**
 * 获取用户信息
 * @param payload
 * @param config
 * @returns {Promise<*>}
 */
export default async function getUserInfoService(payload = {}, config = {}) {
    const param = {
        ...GET_USER_INFO,
        ...config,
        data: payload,
        useNProgress: false
    }

    const { data } = await axios(param)

    if (data.message === HTTP_ERR_SUCCESS_MESSAGE) {
        return data.result || {}
    } else {
        throw new Error(data.errorMessage || ERROR_DEFAULT_HTTP_REQUEST_FAIL)
    }
}
